import React from 'react';
import Image from '../../../atoms/Image';
import FishermanLogo from '../data/fisherman-logo.svg';
export default (function () {
  return /*#__PURE__*/React.createElement(Image, {
    src: FishermanLogo,
    width: 200,
    className: "checkout-fisherman-logo",
    as: "a",
    href: "https://gofisherman.com/",
    target: "_blank"
  });
});